/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsSlideshowClassic = {
	init: function($section) {

    // Add settings from schema to current object
    Shopify.theme.jsSlideshowClassic = $.extend(this, Shopify.theme.getSectionData($section));

    // Selectors
    const $slideshowClassicEl = $section.find('[data-slideshow-classic]').removeClass('is-hidden');

    // const $slideshowClassic = $slideshowClassicEl.flickity({
    //   wrapAround: true,
    //   adaptiveHeight: true,
    //   prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : false,
    //   pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
    //   draggable: true,
    //   imagesLoaded: true,
    //   fade: this.image_transition == 'fade' ? true : false,
    //   autoPlay: this.image_slideshow_speed * 1000,
    //   arrowShape: arrowShape
    // });

    $slideshowClassicEl.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      vertical: true,
      infinite: false,
      verticalSwiping: true,
      adaptiveHeight: true,
      dots: true
    });
   $slideshowClassicEl.on('beforeChange',function(event,slick,currentSlide,nextSlide) {
      if(currentSlide == nextSlide & currentSlide !=0){
        event.preventDefault();
        $('body').css('height','unset');
        $('body').css('overflow','unset');
        setTimeout(function(){
          document.querySelector('#shopify-section-c2-instagram').scrollIntoView({ block: "start", behavior: "smooth" });        
        },200);
      }else{
        
        $('body').css('height','100vh');
        $('body').css('overflow','hidden');
      }
    });
    // Resize flickity when the slider is settled
    $slideshowClassicEl.on( 'settle.flickity', function() {
      $slideshowClassicEl.flickity('resize');
    })

  },
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-image-slideshow]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

    $slider.flickity('select', $sliderIndex, true, true);

  },
	unload: function($section) {

	}
}

/******/ })()
;

  var ticking = false;
  var isFirefox = (/Firefox/i.test(navigator.userAgent));
  var isIe = (/MSIE/i.test(navigator.userAgent)) || (/Trident.*rv\:11\./i.test(navigator.userAgent));
  var scrollSensitivitySetting = 60; //Increase/decrease this number to change sensitivity to trackpad gestures (up = less sensitive; down = more sensitive) 
  var slideDurationSetting = 600; //Amount of time for which slide is "locked"
  var currentSlideNumber = 0;
  var totalSlideNumber;
  
  // ------------- DETERMINE DELTA/SCROLL DIRECTION ------------- //
  function parallaxScroll(evt) {
    if($(".slideshow-classic-vertical.LD .slideshow-classic__banner").length>0){
      totalSlideNumber = $(".slideshow-classic-vertical.LD .slideshow-classic__banner").length;
    }else{
      totalSlideNumber = $(".slideshow-classic-vertical .slideshow-classic__banner").length;
    }
    
    if (isFirefox) {
      //Set delta for Firefox
      delta = evt.detail * (-120);
    } else if (isIe) {
      //Set delta for IE
      delta = -evt.deltaY;
    } else {
      //Set delta for all other browsers
      if($(".slideshow-classic-vertical.LD .slideshow-classic__banner").length>0){
        delta = evt.wheelDelta;
      }else{
        delta = evt.wheelDelta*(3);
        
      }
    }
    if (ticking != true) {
      if (delta <= -scrollSensitivitySetting) {
        //Down scroll
        ticking = true;
        if (currentSlideNumber !== totalSlideNumber - 1) {
          currentSlideNumber++;
          nextItem();
        }else{
          $('body').css('height','unset');
        }
        slideDurationTimeout(slideDurationSetting);
      }
      if (delta >= scrollSensitivitySetting) {
        //Up scroll
        ticking = true;
        
        if (currentSlideNumber !== 0) {
        currentSlideNumber--;
        }
        if(currentSlideNumber + 1 == totalSlideNumber - 1){
          $('html, body').animate({
              scrollTop: 0
          }, 1000);
        }else{
          $('body').css('height','100vh');
          previousItem();
        }
        
        slideDurationTimeout(slideDurationSetting);
      }
    }
  }
  
  // ------------- SET TIMEOUT TO TEMPORARILY "LOCK" SLIDES ------------- //
  function slideDurationTimeout(slideDuration) {
    setTimeout(function() {
      ticking = false;
    }, slideDuration);
  }
  
  // ------------- ADD EVENT LISTENER ------------- //
  var mousewheelEvent = isFirefox ? "DOMMouseScroll" : "wheel";
  window.addEventListener(mousewheelEvent, _.throttle(parallaxScroll, 60), false);
  
  // ------------- SLIDE MOTION ------------- //
  function nextItem() {
    setTimeout(function() {
    $('.slick-next').click();
    }, 50);
  }
  
  function previousItem() {
    setTimeout(function() {
    $('.slick-prev').click()
    }, 50);
  }